import styled from 'styled-components';
import { Box, LinkText, Text, Logo } from '@mediahuis/chameleon-react';
export var PlusInfo = styled('div').withConfig({
  displayName: "styles__PlusInfo",
  componentId: "sc-230pw1-0"
})(["display:flex;flex-direction:row;align-items:flex-start;padding:24px 16px 56px;background:#000c7e;border-radius:16px;margin-bottom:40px;color:#00ff87;font-family:var(--font-family-system);font-weight:700;font-size:16px;line-height:20px;position:relative;"]);
export var PlusInfoHeader = styled('div').withConfig({
  displayName: "styles__PlusInfoHeader",
  componentId: "sc-230pw1-1"
})(["position:absolute;top:-31px;"]);
export var PlusInfoHeaderLogoContainer = styled('div').withConfig({
  displayName: "styles__PlusInfoHeaderLogoContainer",
  componentId: "sc-230pw1-2"
})(["position:absolute;height:35px;width:90px;z-index:1;"]);
export var PlusInfoHeaderLogoContainerAlt = styled('div').withConfig({
  displayName: "styles__PlusInfoHeaderLogoContainerAlt",
  componentId: "sc-230pw1-3"
})(["position:absolute;height:35px;width:90px;z-index:2;transform:translate(-2px,-2px);"]);
export var ShowPasswordToggleButton = styled(Text).withConfig({
  displayName: "styles__ShowPasswordToggleButton",
  componentId: "sc-230pw1-4"
})(["position:absolute;top:40px;right:40px;z-index:1;cursor:pointer;color:rgb(159,158,158);"]);
export var CollapseMoreInfoButton = styled(LinkText).withConfig({
  displayName: "styles__CollapseMoreInfoButton",
  componentId: "sc-230pw1-5"
})(["display:inline-flex;font-weight:500;font-size:16px;font-family:var(--font-family-system);align-items:center;"]);
export var CollapseMoreInfo = styled(Box).withConfig({
  displayName: "styles__CollapseMoreInfo",
  componentId: "sc-230pw1-6"
})([""]);
export var MoreInfoLink = styled(LinkText).withConfig({
  displayName: "styles__MoreInfoLink",
  componentId: "sc-230pw1-7"
})(["display:block;font-family:var(--font-family-system);"]);
export var Container = styled('div').withConfig({
  displayName: "styles__Container",
  componentId: "sc-230pw1-8"
})(["position:absolute;bottom:-10px;"]);
export var ImageLogo = styled('img').withConfig({
  displayName: "styles__ImageLogo",
  componentId: "sc-230pw1-9"
})(["height:35px;@media (min-width:768px){height:48px;}"]);
export var LogoStyled = styled(Logo).withConfig({
  displayName: "styles__LogoStyled",
  componentId: "sc-230pw1-10"
})(["margin:0 8px;@media (min-width:768px){margin:0 15px;}"]);